import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["manager", "other"]

  // Dipanggil saat checkbox Manager diklik
  toggleManager(event) {
    if (event.target.checked) {
      // Jika Manager dicentang, uncheck semua role lain
      this.otherTargets.forEach(checkbox => {
        checkbox.checked = false
      })
    }
  }

  // Dipanggil saat checkbox Lain diklik
  toggleOther(event) {
    if (event.target.checked) {
      // Jika salah satu role lain dicentang, uncheck Manager
      this.managerTargets.forEach(checkbox => {
        checkbox.checked = false
      })
    }
  }
}